import React from "react";
import "./HairBotoxHow.css";
const HairBotoxHow = () => {
  return (
    <div className="hairBotoxHow">
      <h3>How Does Hair Botox Work?</h3>
      <p>
        Hair Botox works by penetrating the hair cuticles and delivering the
        nourishing ingredients deep into the hair cortex. The treatment fills in
        the gaps and breakages in the hair fibers, providing a smooth and
        uniform texture. This process helps to repair damaged areas, reduce
        frizz, and enhance the hair's natural shine. Unlike chemical
        straightening treatments, Hair Botox does not alter the hair's natural
        structure, making it a safer option for those looking to maintain their
        natural curls or waves.
      </p>
      <p>The procedure typically involves the following steps::</p>
        <li>
          <h6>1. Consultation and Hair Analysis:</h6> At SCENT, the process
          begins with a thorough consultation and hair analysis. This step helps
          the stylist understand the client's hair type, concerns, and desired
          results.
        </li>
        <li>
          <h6>2. Cleansing:</h6> The hair is washed with a clarifying shampoo to
          remove any buildup of oils, dirt, and styling products. This step
          ensures that the Hair Botox treatment can penetrate the hair
          effectively.
        </li>
        <li>
          <h6>3. Application:</h6> The Hair Botox treatment is applied to the
          hair, section by section, to ensure even coverage. The product is
          massaged into the hair and left to sit for a specified period,
          allowing the ingredients to work their magic.
        </li>
        <li>
          <h6>4. Rinse and Blow-Dry:</h6> After the treatment has been absorbed,
          the hair is rinsed thoroughly. A blow-dry and flat iron are often used
          to seal the treatment into the hair, enhancing its effectiveness.
        </li>
        <li>
          <h6>5. Styling:</h6> The hair is styled as desired, revealing the
          final result of smooth, shiny, and revitalized tresses.
        </li>
    </div>
  );
};

export default HairBotoxHow;
